module.exports = __webpack_public_path__ + "img/zzcg.cfabce89.png";